<!--
 * @Description: 抽离摘要区字段组件
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="abstract-field-com" ref="abstractField">
    <div class="abstract-field-item" v-for="(item, index) in abstractList" :key="index">
      <template v-if="isShowField(item?.setting?.fieldKey, ruleFields, item?.display)">
        <div class="abstract-field-name form-label-text">
          <component :is="getFieldIcon(item?.setting?.fieldType)" class="abstract-field-icon" />
          <xl-label-text :value="item.setting?.fieldName" :row="1" width="auto" :key="expandCollapse" />
          <div class="abstract-field-toast" v-if="item?.toast">
            <jw-tooltip>
              <qfei-icon-question-mark-outlined size="14" />
              <template #content> {{ item.toast }}</template>
            </jw-tooltip>
          </div>
        </div>
        <div class="abstract-field-value">
          <div class="abstract-field-content" @click.stop="handleClick(index)" :ref="(el) => setRefs(el, index)">
            <template v-if="shouldShowContent(item)">
              <component :is="getfieldShowCom?.[item?.setting?.fieldType == 21 ? item?.setting?.business?.fieldType : item?.setting?.fieldType] || getfieldShowCom[1]" :params="getFieldConfig(item, 1)" :showMore="false" />
            </template>
            <template v-else>
              <template v-if="item?.setting?.fieldKey == 'qccId'">
                <jw-tag size="small" :color="item?.fieldValue ? 'green' : 'pink'">{{ item?.fieldValue ? $t('是') : $t('否') }}</jw-tag>
              </template>
              <template v-else>
                <span class="abstract-field-empty">{{ emptyText }}</span>
              </template>
            </template>
          </div>
          <!-- <div class="fields-content-field-memo" v-if="item?.memo">
          {{ item.memo }}
        </div> -->
        </div>
      </template>
    </div>
    <!-- 编辑容器 -->
    <teleport :to="detailsDrawer" v-if="editIndex != -1">
      <div class="overlay" :style="{ zIndex: contentStyle.zIndex - 1 }" @click.stop="hideEdit"></div>
      <div class="abstract-field-edit-content" :style="contentStyle">
        <field-detail-main :params="getFieldConfig(abstractList[editIndex], 2)" @close="hideEdit" ref="fieldDetailMainRef" type="abstract" />
      </div>
    </teleport>
  </div>
</template>
<script setup>
import { computed, inject, ref, reactive, defineAsyncComponent, nextTick } from 'vue';
import useShowFields from '@/hooks/field-show';
import fieldPermission from '@/hooks/field-permission';
import useFields from '@/hooks/fields';

import { emptyText } from '@/utils/const';

const { getfieldShowCom } = useShowFields();

const { fieldIconMapping } = useFields(); // 获取字段图标
const { isRequiredField, isShowField } = fieldPermission();
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
const FieldDetailMain = defineAsyncComponent(() => import('@/components/fh-set-fields/field-detail-main/index.vue'));
const detailsDrawer = ref(null);
const props = defineProps({
  record: {
    //字段列表
    type: Array,
    default: () => []
  }
});
const contentStyle = ref({
  top: '0',
  left: '0',
  zIndex: 1001
});
const contentRef = reactive({});
const fieldDetailMainRef = ref(null);
// 存储编辑框实例
const setRefs = (el, i) => {
  contentRef[`fields_${i}`] = el;
};

const abstractField = ref(null);

const locked = inject('detailParams')?.locked; //锁定状态
const detailAllFields = inject('detailParams')?.detailAllFields;
const computedError = inject('detailParams')?.computedError; // 计算字段错误信息
const entity = inject('detailParams')?.entity;
const ruleFields = inject('detailParams')?.ruleFields;
const permission = inject('detailParams')?.permission;
const expandCollapse = inject('detailParams')?.expandCollapse;
const abstractList = computed(() => props.record);
// 获取字段的配置
const getFieldConfig = (item, sourceType) => {
  const fieldType = item?.setting?.fieldType == 21 ? item?.setting?.business?.fieldType ?? 21 : item?.setting?.fieldType;
  const fieldExt = item?.setting?.fieldType == 21 ? item?.setting?.business?.fieldExt : item?.setting?.fieldExt;

  const params = {
    col: { ...item?.setting },
    row: {
      ...item,
      lockedOrigin: locked.value,
      id: detailAllFields.value?.id,
      computedInfo: computedError?.value?.length ? computedError?.value?.[0] : null,
      fsContractMultiUrl: detailAllFields.value?.fsContractMultiUrl,
      fsContractId: detailAllFields.value?.fsContractId
    }, // 使用子表单中的数据
    fieldValue: item.fieldValue,
    fieldType: fieldType,
    fieldKey: item?.setting?.fieldKey,
    fieldExt: fieldExt,
    isRequired: isRequiredField(item?.setting?.fieldKey, ruleFields.value, item?.setting?.isRequired),
    isSubForm: false,
    mainField: item?.setting?.mainField,
    entity: entity.value,
    sourceType: sourceType, //1:列表 2：详情
    permissions: permission.value, //权限
    PERMISSION: ruleFields.value,
    showEmptyType: sourceType == 1 ? emptyText : '',
    mask: true //显示蒙层
  };
  return params;
};
// 获取字段图标
const getFieldIcon = (fieldType) => {
  return fieldIconMapping.value[Number(fieldType)];
};

// 判断是否显示内容---为null和undefined、空数组、空对象、空字符串不显示，但等于0或fieldType==24时显示
const shouldShowContent = (item) => {
  const cvf = item?.fieldValue;
  if (item?.setting?.fieldType === 24) return true;
  // null和undefined排除
  if (cvf == null) return false;
  if (cvf === 0) return true;
  if (typeof cvf === 'string') return cvf?.length;
  if (Array.isArray(cvf)) return cvf?.length;
  if (typeof cvf === 'object') return Object.keys(cvf)?.length;
  return true;
};
const editIndex = ref(-1);

const handleClick = async (index) => {
  await nextTick();
  editIndex.value = index;
  let zIndex = 1001;

  const getAditPopup = document?.querySelectorAll('.obj-details-drawer');
  if (getAditPopup && getAditPopup?.length > 0) {
    zIndex = Number(getAditPopup[getAditPopup?.length - 1].style.zIndex) + 2;
    detailsDrawer.value = getAditPopup[getAditPopup?.length - 1];
  }

  if (contentRef[`fields_${index}`]) {
    const contentRect = contentRef[`fields_${index}`]?.getBoundingClientRect();
    const parentRect = detailsDrawer.value?.getBoundingClientRect();

    let left = contentRect?.left - parentRect?.left + 1;
    let right = null;

    if (left + 300 >= parentRect.width) {
      //超出了

      right = parentRect.width - left - contentRect?.width;
      left = null;
    }
    contentStyle.value = {
      top: `${contentRect?.top + 1}px`,
      left: `${left}px`,
      right: `${right}px`,
      zIndex: zIndex
    };
  }
};

const hideEdit = () => {
  editIndex.value = -1;
};
defineExpose({
  hideEdit
});
eventListener('resize', hideEdit);
</script>
<style scoped lang="less">
@import './index.less';
</style>
